import React from "react";
import { 
  Box, 
  Button, 
  Typography, 
  useTheme,
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumb from "../../Atom/Breadcrumbs/Breadcrumb";
import Tooltip from "../../Atom/Tooltip/Tooltip";
import { NavLink, useNavigate } from "react-router-dom";
import machine from "../../../Assets/PNG/machines.png";
import Tooltip1 from "../../Atom/Tooltip/Tooltip-1/Tooltip1";
import Tooltip2 from "../../Atom/Tooltip/Tooltip-2/Tooltip2";
import Tooltip3 from "../../Atom/Tooltip/Tooltip-3/Tooltip3";
import Tooltip4 from "../../Atom/Tooltip/Tooltip-4/Tooltip4";
import Tooltip5 from "../../Atom/Tooltip/Tooltip-5/Tooltip5";
import Tooltip6 from "../../Atom/Tooltip/Tooltip-6/Tooltip6";
import Tooltip7 from "../../Atom/Tooltip/Tooltip-7/Tooltip7";
import Tooltip8 from "../../Atom/Tooltip/Tooltip-8/Tooltip8";
import Tooltip9 from "../../Atom/Tooltip/Tooltip-9/Tooltip9";
import Tooltip10 from "../../Atom/Tooltip/Tooltip-10/Tooltip10";
import { createFlexStyles } from '../../../theme/layoutStyles';

/**
 * Choose Machine component to choose the machine
 * Material UI version
 */
export const ChooseMachine: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const flexStyles = createFlexStyles(theme);

  // Styles following Material UI patterns
  const styles = {
    container: {
        ...flexStyles.flexColumn,
        width: '100%'
      },
    contentContainer: {
        ...flexStyles.flexColumn,
        justifyContent: 'space-between',
        padding: theme.spacing(3.75), // 30px equivalent
        flex: 1
      },
      titleSection: {
        ...flexStyles.flexCenterBetween,
        alignItems: 'flex-start', // Override center alignment
        marginBottom: theme.spacing(3),
        width: '100%'
      },
    titleContent: flexStyles.flexColumn,
    tooltipsContainer: {
      position: 'absolute' as const,
      top: theme.spacing(3.125), // matching paddingTop
      width: '70%',
      left: '50%',
      transform: 'translateX(-50%)',
      height: 'auto',
      aspectRatio: '16 / 8', // Approximate aspect ratio of the machine image
    //   border: `3px solid #e1c411`, // Keep for debugging, remove later
    },
      stepTitle: {
        color: theme.palette.primary.main,
        fontSize: '2rem', // 32px equivalent
        fontWeight: 'normal',
        margin: 0,
      },
      chooseTitle: {
        ...flexStyles.flexCenterGap1,
        fontSize: '1.5rem', // 24px equivalent
        fontWeight: 'normal',
        color: theme.palette.text.primary,
        margin: 0,
        paddingTop: theme.spacing(1.25) // 10px equivalent
      },
    machineContainer: {
      ...flexStyles.flexCenter,
      alignItems: 'flex-start', // Override center alignment
      position: 'relative',
      paddingTop: theme.spacing(3.125) // 25px equivalent
    //   border: `3px solid #e91b21`, // Keep for debugging, remove later
    },
    machineImage: {
      position: 'relative' as const,
      width: '70%',
      height: 'auto',
      objectFit: 'contain' as const,
    },
    buttonContainer: {
      ...flexStyles.flexCenter,
      paddingTop: theme.spacing(2)
    },
    previousButton: {
      backgroundColor: theme.palette.common.white,
    //   border: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.primary,
      padding: theme.spacing(1, 3),
      '&:hover': {
        backgroundColor: theme.palette.grey[50],
        borderColor: theme.palette.primary.main,
      },
    },
  };

  /**
   * Handle previous button click
   */
  const handlePreviousClick = () => {
    navigate("/Design");
  };

  return (
    <Box sx={styles.container}>
      <Breadcrumb />

      <Box sx={styles.contentContainer}>
        {/* Title Section */}

        <Box>
          <Box sx={styles.titleSection}>
            <Box sx={styles.titleContent}>
              <Typography component="h1" sx={styles.stepTitle}>
                Step.2
              </Typography>
              <Typography component="h2" sx={styles.chooseTitle}>
                Choose Position
                <Tooltip name="Click on the industry of your type" />
              </Typography>
            </Box>

            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={styles.previousButton}
              onClick={handlePreviousClick}
            >
              Go Back
            </Button>
          </Box>

          {/* Machine Diagram with Tooltips */}
          <Box sx={styles.machineContainer}>
            <Box
              component="img"
              src={machine}
              alt="Machine diagram with selectable positions"
              sx={styles.machineImage}
            />

            {/* Tooltip Components - maintaining original positioning */}
            <Box sx={styles.tooltipsContainer}>
              <NavLink to="/productdesigns/milkcooler">
                <Tooltip1 />
              </NavLink>
              <NavLink to="#">
                <Tooltip2 />
              </NavLink>
              <NavLink to="#">
                <Tooltip3 />
              </NavLink>
              <NavLink to="#">
                <Tooltip4 />
              </NavLink>
              <NavLink to="#">
                <Tooltip5 />
              </NavLink>
              <NavLink to="#"><Tooltip6 /></NavLink>
              <NavLink to="#"><Tooltip7 /></NavLink>
              <NavLink to="#"><Tooltip8 /></NavLink>
              <NavLink to="#"><Tooltip9 /></NavLink>
              <NavLink to="#"><Tooltip10 /></NavLink>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChooseMachine; 